import React, { Component } from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { Grid } from '@mui/material'
import Button from '../../components/forms/Button'
import Checkbox from '../../components/forms/Checkbox'
import RadioButtons from '../../components/forms/RadioButtons'
import DtoPublicPicture from '../../station/dto/DtoPublicPicture'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'

class PopupExportFile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            additionalDataChecked: false,
            radioChoice: 0,
            radioChoiceModel: 0,
            radioChoiceIndustrial: 0,
            startDate: '',
            endDate: '',
            activeEstablishments: false,
        }
    }

    getBtnExportModel = (modelsElements) => {
        const { radioChoiceModel } = this.state
        const { exportFuncModel } = this.props
        const { name = '' } = modelsElements.find(me => me.code === radioChoiceModel) || {}
        if (radioChoiceModel === 0) {
            return this.getBtnExport()
        }
        return (
            <Grid container sx={{ marginBottom: 0, marginTop: 3 }}>
                <Grid size={12}>
                    <Button
                        title='Excel'
                        onClick={() => exportFuncModel(name)}
                        className='right modal-close'
                    />
                    <Button title={i18n.close} className='left red modal-close' />
                </Grid>
            </Grid>
        )
    }

    getIndustrialSites = () => {
        const { startDate, endDate, activeEstablishments } = this.state
        const { industrialSiteExport } = this.props
        if (industrialSiteExport.data && industrialSiteExport.data.length) {
            const industrialSites = activeEstablishments ? industrialSiteExport.data.filter(i => !i.activityStatus || i.activityStatus != 2) : industrialSiteExport.data
            return {
                ...industrialSiteExport,
                data: industrialSites.filter(e => (!startDate || (!e.agreementStartDate || e.agreementStartDate <= startDate)) && (!endDate || (!e.agreementEndDate || e.agreementEndDate >= endDate))),
            }
        }
        return {}
    }

    getBtnExport = () => {
        const { radioChoice, additionalDataChecked, radioChoiceIndustrial } = this.state
        const { agencyOption, exportFunc } = this.props
        if (agencyOption && radioChoice === 3) {
            return (
                <Grid container sx={{ marginBottom: 0, marginTop: 3 }}>
                    <Grid size={12}>
                        <Button
                            title='Xml'
                            onClick={() => { }}
                            className='right modal-close'
                        />
                        <div className='right padding-left-3' />
                        <Button title={i18n.close} className='left red modal-close' />
                    </Grid>
                </Grid>
            )
        }
        return (
            <Grid container sx={{ marginBottom: 0, marginTop: 3 }}>
                <Grid size={12}>
                    <Button
                        title='Excel'
                        onClick={() => exportFunc('xlsx', additionalDataChecked, radioChoice, radioChoiceIndustrial, this.getIndustrialSites())}
                        className='right modal-close margin-left-1'
                    />
                    <div className='right padding-left-3' />
                    <Button
                        title='CSV'
                        onClick={() => exportFunc('csv', additionalDataChecked, radioChoice, radioChoiceIndustrial, this.getIndustrialSites())}
                        className='right modal-close'
                    />
                    <Button title={i18n.close} className='left red modal-close' />
                </Grid>
            </Grid>
        )
    }

    getModelsExport = (modelsElements) => {
        const { radioChoiceModel } = this.state
        return (
            <Grid container>
                <Grid size={10} offset={2}>
                    <RadioButtons
                        activeOneBelowOther={true}
                        elements={modelsElements}
                        selected={radioChoiceModel}
                        onChange={(v) => this.setState({ radioChoiceModel: v })}
                    />
                </Grid>
            </Grid>
        )
    }

    onResetFilters = () => this.setState({ startDate: '', endDate: '', activeEstablishments: false })

    render() {
        const { additionalDataChecked, radioChoice, radioChoiceIndustrial, startDate, endDate, activeEstablishments } = this.state
        const { useAdditionalData, agencyOption, modelsExport, industrialSiteExport } = this.props
        const elementsRadioButton = [{
            code: 0,
            name: i18n.statementsList,
        }, {
            code: 2,
            name: i18n.agencyExport,
        }, {
            code: 3,
            name: i18n.oasis,
        }]
        const modelsElements = modelsExport.map((model, i) => {
            return { name: model, code: i + 1 }
        })
        const modelsElementsWithOriginModel = [{ name: i18n.resultTable, code: 0 }, ...modelsElements]
        return (
            <div>
                <Grid container>
                    <Grid size={12}>
                        <h5>{i18n.chooseExportFormat}<span style={{ fontStyle: 'italic', fontSize: '18px' }}>&nbsp;({i18n.utf8Format})</span></h5>
                    </Grid>
                </Grid>
                {useAdditionalData && (<Grid container>
                    <Grid size={6}>
                        <Checkbox
                            label={i18n.exportAdditionalData}
                            checked={additionalDataChecked}
                            onChange={(v) => this.setState({ additionalDataChecked: v })}
                        />
                    </Grid>
                </Grid>)}
                {modelsExport.length > 0 && this.getModelsExport(modelsElementsWithOriginModel)}
                {!!(industrialSiteExport.data && industrialSiteExport.data.length) && (
                    <Grid container>
                        <Grid size={10} offset={2}>
                            <RadioButtons
                                activeOneBelowOther={true}
                                elements={[
                                    {
                                        code: 0,
                                        name: i18n.resultsTable,
                                    },
                                    {
                                        code: 1,
                                        name: i18n.potentialSourcesPollution,
                                    },
                                ]}
                                selected={radioChoiceIndustrial}
                                onChange={(v) => this.setState({ radioChoiceIndustrial: v })}
                            />
                        </Grid>
                        {radioChoiceIndustrial === 1 && (
                            <Grid size={12}>
                                <fieldset>
                                    <legend>{i18n.criterias}</legend>
                                    <Grid container spacing={1}>
                                        <Grid size={3}>
                                            <SimpleDatePicker
                                                label={i18n.startDate}
                                                onChange={v => this.setState({ startDate: v })}
                                                id='startDate'
                                                value={startDate}
                                                max={endDate}
                                            />
                                        </Grid>
                                        <Grid size={3}>
                                            <SimpleDatePicker
                                                label={i18n.endDate}
                                                onChange={v => this.setState({ endDate: v })}
                                                id='endDate'
                                                value={endDate}
                                                min={startDate}
                                            />
                                        </Grid>
                                        <Grid size={3}>
                                            <Checkbox
                                                componentClassName='padding-top-10-px'
                                                checked={activeEstablishments}
                                                onChange={v => this.setState({ activeEstablishments: v })}
                                                label={i18n.activeEstablishments}
                                            />
                                        </Grid>
                                        <Grid size={3}>
                                            <a className='margin-1 waves-effect waves-teal center btn-flat secondary-button right' onClick={this.onResetFilters}>
                                                {i18n.reinit}
                                            </a>
                                        </Grid>
                                    </Grid>
                                </fieldset>
                            </Grid>
                        )}
                    </Grid>
                )}
                {agencyOption && (<Grid container>
                    <Grid size={7} offset={2}>
                        <RadioButtons
                            activeOneBelowOther={true}
                            elements={elementsRadioButton}
                            selected={radioChoice}
                            onChange={(v) => this.setState({ radioChoice: v })}
                        />
                    </Grid>
                </Grid>)}
                {modelsExport.length > 0 ? this.getBtnExportModel(modelsElementsWithOriginModel) : this.getBtnExport()}
            </div>
        )
    }
}

PopupExportFile.propTypes = {
    useAdditionalData: PropTypes.bool,
    agencyOption: PropTypes.bool,
    exportFunc: PropTypes.func,
    modelsExport: PropTypes.arrayOf(PropTypes.instanceOf(DtoPublicPicture)),
    exportFuncModel: PropTypes.func,
    industrialSiteExport: PropTypes.shape({
        data: PropTypes.array,
        exportType: PropTypes.string,
        titleFile: PropTypes.string,
    }),
}

PopupExportFile.defaultProps = {
    useAdditionalData: false,
    agencyOption: false,
    exportFuncModel: () => { },
}

export default PopupExportFile